<div class="nav-body tabs-shadow">
  <ul class="nav nav-tabs pl-0 mx-0 mb-0 " >
    <li class="li-m primary-text light-text tabs-title pb-2 mr-8" *ngFor="let tab of tabs; let i = index" (click)="selectTab(tab,i)" [class.active]="tab.active" [ngClass]="{ 'tabs-shadow-selected black-text': tab.active }"  >
      <a>{{tab.title}}</a>
    </li>
  </ul>
  <div class="nav-body-right pr-2">
    <p class="label-text content-m light-text m-0" *ngIf="editState">{{'Rule Id: '}}{{ruleId}}</p>
    <img src="../../../../assets/close-dialog.svg" class="icon-l enable-action" (click)="close()">
  </div>
  
</div>

<ng-content></ng-content>
